<div class="container main-layout">
    <div class="right-container">
      <div class="animation">
        <div class="abio-heading" ><div class="abro">  </div> </div>
        <!-- <div class="abio-heading" *ngIf="!menuForTrainer"><div class="abro">{{this.config.RolePlay.DisplayText}}</div> </div> -->
      </div>
      <button class="right-button" (click)="CreateTemp()">
        <span>+ Create Template</span>
      </button>
      <div class="head-block">
        <div class="hb-top">
          <span class="head-text"> Explore Email Templates </span>
          <!-- <span class="head-text" *ngIf="!menuForTrainer"> Assigned {{this.config.RolePlay.DisplayText}}</span> -->
          <span class="sub-heading">Discover and train with email templates</span>
        </div>
        <div class="search-container">
          <span><img src="../../../assets/images/search-lefticon.png" alt=""></span>
          <input matInput #searchInput placeholder="Search email templates" class="search-box" (input)="applyFilter(searchInput.value)">
          <div class="search-icon"><img src="../../../assets/images/searchabio.png" alt=""></div>
        </div>
        <div *ngIf="showNoCardsMessage">
          No search results found.
        </div>
        <!-- <button *ngIf="menuForTrainer" class="right-button1" (click)="createScenario()">
          <span>+ Create Scenario</span>
        </button> -->
      </div>
      
      
            <!-- email-template.component.html -->
<div class="container scroll">
    <div class="row" >
        <div class="column"  *ngFor="let item of filteredItems">
            <div class="card"  *ngIf="!showNoCardsMessage">
          <div class="card-top-div">
            <!-- Display template details -->
            <div class="ctd-1" >
                <div>
              <!-- <span class="card-s1">{{ item.id }}</span></div> -->
             <div> <span class="card-s2" title="{{item.template_name}}"> {{ item.template_name | truncate:15}}</span></div>
             <div><span class="card-s3" title="{{item.subject}}"> {{ item.subject | truncate:15}}</span></div>
            </div>
            
          </div>
          <div class="ctd-2" > <button mat-button [matMenuTriggerFor]="menu" class="dots"><div class="dot-align">...</div></button>
                <mat-menu #menu="matMenu">
                  <!-- <button class="option" (click)="updateScenario(item.id)" mat-menu-item>Edit</button>
                  <button (click)=" delete(item.id)" class="option" mat-menu-item>Delete</button> -->
                  <button class="option" (click)="updateTemplate(item.id)" mat-menu-item>Edit</button>
                  <!-- <button  class="option" (click)=" delete(item.id)" mat-menu-item>Delete</button> -->
                </mat-menu>
              </div>
        </div>
      </div>
    </div>
  
  
          <!-- <div class="column"  *ngFor="let item of filteredItems.length ? filteredItems : items">
            <div class="card"  *ngIf="!showNoCardsMessage">
              <div class="card-top-div">
                <div class="ctd-1">
                  <span class="card-s2"   [title]="item.scenario_name" (click)="cardClickHandler(item)">{{ item.scenario_name  | truncate:15}} </span>
                  <span class="card-s1" *ngIf="!menuForTrainer" (click)="cardClickHandler(item)">{{ item.roleplay_status }}</span>
                </div>
                <div class="ctd-2" *ngIf="menuForTrainer"> <button mat-button [matMenuTriggerFor]="menu" class="dots"><div class="dot-align">...</div></button>
                  <mat-menu #menu="matMenu">
                    <button class="option" (click)="updateScenario(item.scenario_id)" mat-menu-item>Edit</button>
                    <button (click)=" delete(item.scenario_id)" class="option" mat-menu-item>Delete</button>
                    <button class="option" mat-menu-item
                      (click)="redirectToAssignRoleplay(item.scenario_id)">Assign</button>
                  </mat-menu>
                </div>
                <div class="ctd-2" *ngIf="!menuForTrainer">
                  <span><img src="../../../assets/images/info-icon.svg" alt=""></span>
                    
                  <div class="roleplay-tooltip">
                      <span>Objectives of Roleplay</span>
                      <ul *ngIf="item.objectives">
                          <li *ngFor="let item of item.objectives">{{item}}</li>
                      </ul>
                      <ul *ngIf="!item.objectives">
                          <li>NA</li>
                      </ul>
                  </div>
              </div>
              </div>
              <div class="header">
                <span class="card-s1" *ngIf="menuForTrainer"  (click)="cardClickHandler(item)">Created on {{ item.created_date }}</span>
                <span class="card-s3" *ngIf="item.objectives" (click)="cardClickHandler(item)" title="{{item.objectives[0]}}">{{ (item.objectives) ? item.objectives[0] : "" }}
                </span>
              </div>
            </div>
          </div> -->
       
      </div>
    </div>
  </div>